'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { setToSessionStorage } from 'utils/webStorage/sessionStorage'

import { PREVIOUS_URL_KEY } from '../constants'

export const StorePreviousUrl = () => {
	const pathname = usePathname()

	useEffect(() => {
		setToSessionStorage(PREVIOUS_URL_KEY, pathname)
	}, [])

	return null
}
